import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    // If we are not on the home page, let the default anchor link behavior work
    if (window.location.pathname !== '/') {
      return;
    }
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const navHeight = 64;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navHeight;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      window.history.pushState(null, '', `#${sectionId}`);
      setIsOpen(false);
    }
  };
  const scrollToTop = (e: React.MouseEvent) => {
    if (window.location.pathname !== '/') {
      return;
    }
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    window.history.pushState(null, '', window.location.pathname);
  };
  return <div className="fixed top-0 left-0 right-0 z-50" data-id="element-195">
      {/* Promo Bar */}
      <a href="/#contact" className="block w-full bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-500 text-black text-center py-1.5 px-4 text-sm md:text-base font-black uppercase tracking-wide hover:from-yellow-400 hover:via-yellow-300 hover:to-yellow-400 transition-all cursor-pointer" data-id="element-196">
        🔥 Limited Time Only! <span className="text-red-700" data-id="element-197">$50 OFF</span>{' '}
        Listed Price of Full Details — Call Now!
      </a>

      <nav className="bg-black/95 backdrop-blur-sm border-b border-zinc-900" aria-label="Main navigation" data-id="element-198">
        <div className="max-w-7xl mx-auto px-4" data-id="element-199">
          <div className="flex items-center justify-between h-16" data-id="element-200">
            {/* Logo */}
            <a href="/" onClick={scrollToTop} className="text-xl font-black uppercase tracking-tight" aria-label="Mike's Pro Detail - Home" data-id="element-201">
              <span className="text-white" data-id="element-202">Mike's</span>{' '}
              <span className="text-red-600" data-id="element-203">Pro Detail</span>
            </a>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-6" data-id="element-204">
              <a href="/#services" onClick={e => scrollToSection(e, 'services')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-205">
                Services
              </a>
              <a href="/#about" onClick={e => scrollToSection(e, 'about')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-206">
                About
              </a>
              <a href="/#gallery" onClick={e => scrollToSection(e, 'gallery')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-207">
                Gallery
              </a>
              <a href="/#reviews" onClick={e => scrollToSection(e, 'reviews')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-208">
                Reviews
              </a>
              <a href="/#faq" onClick={e => scrollToSection(e, 'faq')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-209">
                FAQ
              </a>
              <a href="/#contact-form" onClick={e => scrollToSection(e, 'contact-form')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-210">
                Contact Us
              </a>
              <a href="tel:8183819905" className="flex items-center gap-2 px-5 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded transition-colors" aria-label="Call Mike's Pro Detail" data-id="element-211">
                <Phone className="w-4 h-4" data-id="element-212" />
                <span className="text-base tracking-tight" data-id="element-213">(818) 381-9905</span>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-white p-2" aria-label="Toggle menu" data-id="element-214">
              {isOpen ? <X className="w-6 h-6" data-id="element-215" /> : <Menu className="w-6 h-6" data-id="element-216" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isOpen && <div className="md:hidden py-4 border-t border-zinc-900" data-id="element-217">
              <div className="flex flex-col gap-4" data-id="element-218">
                <a href="/#services" onClick={e => scrollToSection(e, 'services')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-219">
                  Services
                </a>
                <a href="/#about" onClick={e => scrollToSection(e, 'about')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-220">
                  About
                </a>
                <a href="/#gallery" onClick={e => scrollToSection(e, 'gallery')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-221">
                  Gallery
                </a>
                <a href="/#reviews" onClick={e => scrollToSection(e, 'reviews')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-222">
                  Reviews
                </a>
                <a href="/#faq" onClick={e => scrollToSection(e, 'faq')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-223">
                  FAQ
                </a>
                <a href="/#contact-form" onClick={e => scrollToSection(e, 'contact-form')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-224">
                  Contact Us
                </a>
                <a href="tel:8183819905" className="flex items-center justify-center gap-2 px-5 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded transition-colors" aria-label="Call Mike's Pro Detail" data-id="element-225">
                  <Phone className="w-4 h-4" data-id="element-226" />
                  <span className="text-base tracking-tight" data-id="element-227">
                    (818) 381-9905
                  </span>
                </a>
              </div>
            </div>}
        </div>
      </nav>
    </div>;
}